import { CentricTheme } from './ui/components/interfaces/CentricTheme';
import * as React from 'react';

export interface StyledProps {
  classes?: any;
  className?: string
  style?: React.CSSProperties
}

export interface ThemedProps {
  theme?: CentricTheme
}
export {CentricTheme}

export {withStyles} from '@material-ui/core'

import * as thirdparty from './3rd-party'
export {thirdparty}

export * from './3rd-party'
//export * from '@modules/components'




// WEBPACK FOOTER //
// ./src/shared/components/index.ts